export const collapsibleBarClasses = {
    root: 'BinoCollapsibleBar_root',
    innerCollapsible: 'BinoCollapsibleBar_innerCollapsible',
    content: 'BinoCollapsibleBar_content',
    innerContent: 'BinoCollapsibleBar_innerContent',
    triggerButtonContainer: 'BinoCollapsibleBars_triggerButtonContainer',
    triggerButton: 'BinoCollapsibleBars_triggerButton',
};
